import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import Text from '../../../Text'
import { QA_NAME_DASHBOARD_BIRDVIEW_RESET_LAYOUT } from '../../DashboardBirdview.constants.qa'

import * as styles from './BirdviewChartCatalogFooter.module.css'

function BirdviewChartCatalogFooter({ shownCount, totalCount, onReset }) {
  const { t } = useTranslation()

  return (
    <div className={styles.footer}>
      <Text isSecondary>
        {t('DashboardBirdview.ChartCatalogShownCountKey', {
          shown: shownCount,
          total: totalCount,
        })}
      </Text>
      <Button.Text
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_RESET_LAYOUT}
        text={t('DashboardBirdview.ChartCatalogResetButtonTextKey')}
        onClick={onReset}
      />
    </div>
  )
}

export default BirdviewChartCatalogFooter
